import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'FeatureItems',
})(({ brandColors, spacing, breakpoints, typography }) => ({
  features: {
    marginBottom: spacing(2),
    '& > *:not(:first-child):not(:last-child)': {
      marginTop: spacing(0),
      marginBottom: spacing(0),
    },
  },
  featureContainer: {
    display: 'flex',
    flexDirection: 'row',
    color: brandColors.black,
    '&.darkMode': {
      color: brandColors.white,
    },
  },
  featureIcon: {
    display: 'flex',
    alignItems: 'center',
    width: typography.pxToRem(24),
    height: typography.pxToRem(24),
    marginRight: spacing(0),
    [breakpoints.up('sm')]: {
      marginRight: spacing(1),
    },
  },
}));

export default useStyles;
